export default function cloneWithoutValidations (inputProps) {
    return Object.assign({}, inputProps, { validations: undefined })
}